import { render, staticRenderFns } from "./SuspendedRow.vue?vue&type=template&id=18918fe6"
import script from "./SuspendedRow.vue?vue&type=script&lang=js"
export * from "./SuspendedRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports